function onlyOne(vals) {
    //Adds up bool values of the array, false is 0 and true is 1
    const truthyCount = vals.reduce((a, c) => a + !!c, 0);
    return 1 === truthyCount;
}
export default onlyOne;
